module.exports = __webpack_public_path__ + "img/selfbio-logo-6.e8d763bc.png";